/**
 * Kontaktformular (Element pa-contact, Server: pa-core/inc/forms.php).
 *
 *  - Formular ist im HTML „hidden“ und erscheint erst mit JS (ohne JS: Hinweis auf die Mailadresse)
 *  - misst die Ausfüllzeit ab dem Laden (Server verwirft < 3 s als Bot)
 *  - prüft vor dem Senden selbst (Pflichtfelder, E-Mail-Format) und zeigt Fehler am Feld (aria-invalid + Text),
 *    Fokus springt ins erste fehlerhafte Feld; Fehler des Servers (422) landen an denselben Stellen
 *  - Senden per fetch als JSON; währenddessen Knopf gesperrt; Erfolg ersetzt das Formular durch die Bestätigung
 */
import { qs, qsa } from '../utils/dom.js';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

function setError(form, name, message) {
	const input = form.elements.namedItem(name);
	if (!input) return;
	const error = qs(`#${input.id}-error`, form);
	if (message) input.setAttribute('aria-invalid', 'true');   // leerer Wert würde als „false“ gelten
	else input.removeAttribute('aria-invalid');
	input.closest('.pa-field')?.classList.toggle('is-invalid', !!message);
	if (error) error.textContent = message || '';
}

function validate(form) {
	const errors = {};
	qsa('.pa-field__input', form).forEach((input) => {
		const value = input.value.trim();
		if (input.required && !value) errors[input.name] = 'Bitte ausfüllen.';
		else if (input.type === 'email' && value && !EMAIL.test(value)) errors[input.name] = 'Bitte eine gültige E-Mail-Adresse angeben.';
		else if (input.name === 'message' && value && value.length < 10) errors[input.name] = 'Bitte ein paar Worte mehr.';
	});
	return errors;
}

function showErrors(form, errors) {
	qsa('.pa-field__input', form).forEach((input) => setError(form, input.name, errors[input.name]));
	const first = qsa('.pa-field__input', form).find((input) => errors[input.name]);
	first?.focus();
}

function initForm(form) {
	const wrap = form.parentElement;
	const success = qs('[data-pa-form-success]', wrap);
	const nojs = qs('[data-pa-form-nojs]', wrap);
	const status = qs('.pa-form__status', form);
	const button = qs('.pa-form__submit', form);
	const started = Date.now();

	form.hidden = false;
	if (nojs) nojs.hidden = true;

	// Fehler am Feld verschwinden, sobald man es korrigiert
	form.addEventListener('input', (e) => {
		if (e.target.matches?.('.pa-field__input') && e.target.hasAttribute('aria-invalid')) setError(form, e.target.name, '');
	});

	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		if (form.classList.contains('is-sending')) return;
		status.textContent = '';

		const errors = validate(form);
		if (Object.keys(errors).length) {
			showErrors(form, errors);
			status.textContent = 'Bitte prüfen Sie die markierten Felder.';
			return;
		}

		const payload = Object.fromEntries(new FormData(form).entries());
		payload.elapsed = Date.now() - started;
		payload.page = window.location.href.split('#')[0];

		form.classList.add('is-sending');
		button.disabled = true;
		button.setAttribute('aria-busy', 'true');

		try {
			const response = await fetch(form.action, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify(payload),
				credentials: 'same-origin',
			});
			const data = await response.json().catch(() => ({}));

			if (response.ok && data.ok) {
				form.hidden = true;
				if (success) {
					success.hidden = false;
					success.focus();
				}
				return;
			}
			if (response.status === 422 && data.errors) showErrors(form, data.errors);
			status.textContent = data.message || 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder schreiben Sie mir direkt per E-Mail.';
		} catch {
			status.textContent = 'Keine Verbindung. Bitte versuchen Sie es noch einmal oder schreiben Sie mir direkt per E-Mail.';
		} finally {
			form.classList.remove('is-sending');
			button.disabled = false;
			button.removeAttribute('aria-busy');
		}
	});
}

export function init() {
	qsa('[data-pa-form]').forEach(initForm);
}
